import View from './View';

export default class ViewPressroom extends View {
	constructor(el) {
		super(el);

		// -- Properties
		//--------------------------------------------------------------
		$.extend(this.dom, {
			newsFilter: this.dom.el.find('[data-action="news-filter"]'),
			contactFilter: this.dom.el.find('select[name=ContactListGroupFilter]'),
			pressKitFilter: this.dom.el.find('[data-action="presskit-filter"]'),
			pressReleaseFilter: this.dom.el.find(
				'[data-action="pressreleases-filters"]'
			),
			mediaFilter: this.dom.el.find('[data-action="pressmedia-filter"]'),
			mediaFilters: this.dom.el.find('[data-action="pressmedia-filters"]'),
			spinner: this.dom.el.find('.spinner'),
			categoryFilter: this.dom.el.find('select[name=CategoryFilter]'),
			countryFilter: this.dom.el.find('select[name=CountryFilter]'),
			yearFilter: this.dom.el.find('select[name=YearFilter]'),
			showFilter: this.dom.el.find('select[name=ShowFilter]'),
			mediaTypeFilter: this.dom.el.find('select[name=MediaTypeFilter]'),
			galleryFilter: this.dom.el.find('select[name=GalleryFilter]'),
			elemTrigger: this.dom.el.find('.accordion-section h2'),
			pressRoomMenu: this.dom.el.find('[data-action="pressroom-menu"]'),
			pressRoomMenuToggle: this.dom.el.find(
				'[data-action="pressroom-menu-toggle-mobile"]'
			),
			pressRoomMenuOffset: this.dom.el.find('.pressroom-menu-offset'),
			menuContacts: this.dom.el.find('.menu-contacts'),
			newsSummary: this.dom.el.find('[data-action="truncate"]'),
		});
	}

	init() {
		super.init();

		this.bindEvents();
		this.setTruncate();
		this.dom.spinner.hide();
	}

	bindEvents() {
		const $this = this;

		this.dom.el.find('.fbShare').on('click', (e) => {
			e.preventDefault();
			FB.ui(
				{
					method: 'share',
					href: window.location.href,
				},
				function (response) {}
			);
		});

		this.dom.el.find('.js-collapse').on('click', function (e) {
			e.preventDefault();
			const self = $(this);
			const dropdown = self.next();
			self.toggleClass('is-open');
			dropdown.slideToggle();
		});

		this.dom.newsFilter.on('change', (event) => {
			window.location.href = this.getFilteredUrl();
		});

		this.dom.mediaTypeFilter.on('change', (event) => {
			window.location.href = this.dom.mediaTypeFilter.val();
		});

		this.dom.galleryFilter.on('change', (event) => {
			window.location.href = this.dom.galleryFilter.val();
		});

		this.dom.categoryFilter.on('change', (event) => {
			window.location.href = this.dom.categoryFilter.val();
		});

		this.dom.countryFilter.on('change', (event) => {
			window.location.href = this.dom.countryFilter.val();
		});

		this.dom.yearFilter.on('change', (event) => {
			window.location.href = this.dom.yearFilter.val();
		});

		this.dom.pressKitFilter.on('change', (event) => {
			$.ajax({
				type: 'GET',
				url: '/press/api/kits/presskitsshowsapi/v1.0/get',
				data: {
					itemId: window.sitecoreRequestObject.ItemId,
					lang: window.sitecoreRequestObject.Lang,
					country: this.dom.el.find('.presskit-filter').val(),
				},
				dataType: 'html',
				success(data) {
					$('.presskits').html(data);
				},
				error(error) {
					console.log(error);
				},
			});
		});

		this.dom.contactFilter.on('change', (event) => {
			window.location.href = this.dom.contactFilter.val();
		});

		this.dom.elemTrigger.on('click', (event) => {
			ViewPressroom.manageSection(event);
		});
	}

	getParameterByName(url, name) {
		name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
		const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
		const results = regex.exec(url);
		return results === null
			? ''
			: decodeURIComponent(results[1].replace(/\+/g, ' '));
	}

	getFilteredUrl() {
		const rawUrl = this.dom.pressReleaseFilter[0].getAttribute('data-rawurl');
		const tokens = rawUrl.split('/');
		let url = rawUrl.split('?')[0];
		const page = this.getParameterByName(rawUrl, 'page');
		const category = this.dom.categoryFilter.val();
		const country = this.dom.countryFilter.val();
		const year = this.dom.yearFilter.val();

		if (country !== null && country !== '') {
			if (tokens.length === 4) {
				// Localized
				url = `/${tokens[1]}/${country}/${tokens[2]}/${tokens[3]}`;
			} else {
				url = `/${country}${url}`;
			}
		}

		if (category !== null && category !== '') {
			url = `${url}/${category}`;
		}

		if (year !== null && year !== '') {
			url = `${url}/${year}`;
		}

		return url;
	}

	static manageSection(event) {
		const parent = event.currentTarget.closest('.accordion-section');
		const sectionId = event.currentTarget.dataset.id;
		const section = document.querySelector(`[data-section="${sectionId}"]`);

		if (parent.classList.contains('open')) {
			parent.classList.remove('open');
			section.classList.remove('open');
		} else {
			parent.classList.add('open');
			section.classList.add('open');
		}
	}

	setTruncate() {
		this.dom.newsSummary.dotdotdot({
			ellipsis: '...',
			watch: true,
			wrap: 'letter',
			height: 20 * 3, // max number of lines
		});
	}
}
